// extracted by mini-css-extract-plugin
module.exports = {"root":"Speech_root__yq1w9","videoHolder":"Speech_videoHolder__3xYWM","buttonGroup":"Speech_buttonGroup__28GY6","inner":"Speech_inner__2SHM1"};